export const userConstant = {
    GET_ALL_FAIL: 'GET_ALL_USER_FAIL',
    GET_ALL_SUCCESS: 'GET_ALL_USER_SUCCESS',
    GET_ALL_REQUEST: 'GET_ALL_USER_REQUEST',
    GET_REQUEST: 'GET_USER_REQUEST',
    GET_SUCCESS: 'GET_USER_SUCCESS',
    GET_FAIL: 'GET_USER_FAIL',
    ADD_REQUEST: 'ADD_USER_REQUEST',
    ADD_SUCCESS: 'ADD_USER_SUCCESS',
    ADD_FAIL: 'ADD_USER_FAIL',
    UPDATE_REQUEST: 'UPDATE_USER_REQUEST',
    UPDATE_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_FAIL: 'UPDATE_USER_FAIL',
    REMOVE_REQUEST: 'REMOVE_USER_REQUEST',
    REMOVE_SUCCESS: 'REMOVE_USER_SUCCESS',
    REMOVE_FAIL: 'REMOVE_USER_FAIL',
    RESET: 'RESET_USER'
};

export default userConstant;